<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="sienit">N</span>
          <input type="text" placeholder="Търсене" v-model="searchUsers" />
        </div>
        <span class="sienit modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content" v-if="!isComingFromReport">
        <div
          class="modal-content-check"
          v-for="user in filteredUsers"
          :key="`addUsersModal-${user._id}`"
        >
          <label
            class="checkbox-wrapper"
            :class="{ 'checkbox-wrapper--disabled': user.isReleased }"
            :title=" user.isReleased ? 'Служителят е освободен' : null"
          >
            {{user.name}}
            <input
              type="checkbox"
              :id="user._id"
              v-model="user.isSelected"
              :disabled="user.isReleased"
            />
            <span class="checkmark"></span>
          </label>
        </div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="users.length && !filteredUsers.length">
          Няма намерени резултати за '
          <strong>{{this.searchUsers}}</strong>'
        </p>
      </div>
      <div class="modal-content" v-else>
        <div
          class="modal-content-item"
          v-for="(user, index) in filteredUsers"
          :key="`addUsersModal-${index}-${user._id}`"
          @click="saveSingle(user)"
        >{{ user.name }}</div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="users.length && !filteredUsers.length">
          Няма намерени резултати за '
          <strong>{{this.searchUsers}}</strong>'
        </p>
      </div>
      <div class="modal-footer">
        <div class="select-btns" v-if="!isComingFromReport">
          <button class="btn btn-select" @click="toggleUsers(true)">
            <span class="sienit">W</span>
            Всички
          </button>
          <button class="btn btn-select" @click="toggleUsers(false)">
            <span class="sienit">X</span>
            Никой
          </button>
        </div>
        <button v-if="!isComingFromReport" class="btn btn-new" @click="save()">
          <span class="sienit">Y</span>
          Запази
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['usersType', 'incomingUsers', 'isComingFromReport', 'unitID'],
  data() {
    return {
      users: [],
      searchUsers: ''
    };
  },
  computed: {
    filteredUsers() {
      return this.filterUsers();
    }
  },
  methods: {
    getAllUsers() {
      let url = `${process.env.VUE_APP_BASE_URI}/auth/users`

      url += `?userPermission=${this.usersType}`;

      if(this.usersType === 'isAllProjectsReporter') {
        if(this.unitID) url += `&unitID=${this.unitID}`
        else url += `&noUnit=true`
      }

      this.$http
        .get(url)
        .then(response => {
          this.users = response.data;
          if (this.incomingUsers) {
            this.incomingUsers.forEach(iu => {
              this.users.forEach(u => {
                if (u._id === iu._id) {
                  u.isSelected = true;
                }
              });
            });
          }
        });
    },
    filterUsers() {
      return this.users.filter(u => {
        return u.name.toLowerCase().includes(this.searchUsers.toLowerCase());
      });
    },
    toggleUsers(toggle) {
      // If searching select only results
      if (this.searchUsers.length) {
        const tempFilteredUsers = this.filterUsers();
        this.users.forEach((u, index) => {
          tempFilteredUsers.forEach(fu => {
            if (fu._id === u._id) {
              let user = u;
              if (!user.isReleased) {
                user.isSelected = toggle;
              }

              this.$set(this.users, index, user);
            }
          });
        });
      }
      // Otherwise select/deselect all
      else {
        this.users.forEach((u, index) => {
          let user = u;
          if (!user.isReleased) {
            user.isSelected = toggle;
          }

          this.$set(this.users, index, user);
        });
      }
    },
    getSelectedUsers() {
      return this.users.filter(u => {
        return u.isSelected;
      });
    },
    close() {
      this.$parent.$emit('closeAddUsersModal');
    },
    saveSingle(u) {
      this.$parent.$emit('saveAddUsersModal', {
        _id: u._id,
        name: u.name
      });
    },
    save() {
      this.$parent.$emit('saveAddUsersModal', this.getSelectedUsers());
    }
  },
  mounted() {
    this.getAllUsers();
  }
};
</script>

<style scoped>
/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-content-check {
    width: 45%;
  }
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
